// extracted by css-extract-rspack-plugin
export default {"paperContainer":"src-domain-components-logical-device-sync-configuration-modal-LogicalDeviceSyncConfigurationModal-module__paperContainer-Khz6zy","modalActions":"src-domain-components-logical-device-sync-configuration-modal-LogicalDeviceSyncConfigurationModal-module__modalActions-vZtNm4","customActionsClassName":"src-domain-components-logical-device-sync-configuration-modal-LogicalDeviceSyncConfigurationModal-module__customActionsClassName-iVeB1X","modalContent":"src-domain-components-logical-device-sync-configuration-modal-LogicalDeviceSyncConfigurationModal-module__modalContent-_eRoOt"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"paperContainer\":\"src-domain-components-logical-device-sync-configuration-modal-LogicalDeviceSyncConfigurationModal-module__paperContainer-Khz6zy\",\"modalActions\":\"src-domain-components-logical-device-sync-configuration-modal-LogicalDeviceSyncConfigurationModal-module__modalActions-vZtNm4\",\"customActionsClassName\":\"src-domain-components-logical-device-sync-configuration-modal-LogicalDeviceSyncConfigurationModal-module__customActionsClassName-iVeB1X\",\"modalContent\":\"src-domain-components-logical-device-sync-configuration-modal-LogicalDeviceSyncConfigurationModal-module__modalContent-_eRoOt\"}";
        // 1793705032613
        var cssReload = require("../../../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  